module.exports = __webpack_public_path__ + "static/media/roundingDisabled.4902ee51.png";